/* eslint-disable */
// Hand-authored, IP-safe holiday loader scene (Star Wars Day, May 4) in the handoff idiom.
const rnd = (a, b) => a + Math.random() * (b - a);

/* ---- Star Wars Day (May 4): a deep starfield over twin suns setting on a
        distant dune horizon. IP-SAFE — original silhouettes only: the hero is
        EITHER a round-topped astro-droid rolling across the dune, OR an
        energy-sword hilt igniting a glowing coloured blade. A large distant
        ringed planet and a faint nebula wash sit low-left, tiny far-off
        starships streak across the sky, and a shooting star / ship streak
        crosses. Deep indigo-navy space with a warm twin-sun horizon glow;
        the composited centre badge zone (x 150-210, y 82-138) stays clear. ---- */
function starWarsScene() {
  const pick = (a) => a[Math.floor(Math.random() * a.length)];
  const uid  = 'sw' + Math.random().toString(36).slice(2, 7);

  // ---- rolled traits ----
  const AC     = pick(['#4fd8ff', '#5cf08a', '#c08bff', '#ff8f57']); // droid eye / glow accent
  const streak = pick(['shoot', 'ship', 'shoot']);                  // faint shooting star or ship light-streak

  // ---- deep starfield, two parallax layers (kept out of the calm centre band by scatter + tiny size) ----
  let farStars = '';   // distant, dim, small
  for (let i = 0; i < 18; i++) {
    const x = rnd(6, 354), y = rnd(4, 150), r = rnd(0.4, 0.95), d = rnd(0, 3), o = rnd(0.18, 0.5);
    farStars += `<circle class="twinkle" cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(2)}" fill="#c7d6f5" opacity="${o.toFixed(2)}" style="animation-delay:${d.toFixed(2)}s"/>`;
  }
  let stars = '';      // nearer, brighter
  for (let i = 0; i < 24; i++) {
    const x = rnd(6, 354), y = rnd(4, 146), r = rnd(0.7, 1.9), d = rnd(0, 2.4), o = rnd(0.5, 1);
    stars += `<circle class="twinkle" cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(1)}" fill="#eaf3ff" opacity="${o.toFixed(2)}" style="animation-delay:${d.toFixed(2)}s"/>`;
  }

  // ---- faint shooting star / ship streak (class on inner g; outer g carries the position) ----
  const trail = streak === 'ship'
    ? `<g transform="translate(0,28)"><g class="sw-streak"><rect x="0" y="-0.6" width="22" height="1.2" rx="0.6" fill="#bfe8ff" opacity="0.85"/><circle cx="22" cy="0" r="1.5" fill="#ffffff"/></g></g>`
    : `<g transform="translate(10,6)"><g class="shoot"><path d="M0,0 L-16,-7" stroke="#ffffff" stroke-width="1.3" stroke-linecap="round" opacity="0.55"/><circle r="1.7" fill="#ffffff"/></g></g>`;

  // ---- a couple of tiny far-off starships crossing high on the right (reuses .shoot) ----
  const ships =
      `<g transform="translate(214,14)"><g class="shoot" style="animation-delay:-2.5s"><g transform="scale(0.5)"><path d="M0,0 L-20,-9" stroke="#bfe8ff" stroke-width="1.8" stroke-linecap="round" opacity="0.55"/><circle r="1.8" fill="#e6f5ff"/></g></g></g>`
    + `<g transform="translate(250,40)"><g class="shoot" style="animation-delay:-5s"><g transform="scale(0.42)"><path d="M0,0 L-20,-9" stroke="#cfe8ff" stroke-width="1.8" stroke-linecap="round" opacity="0.4"/><circle r="1.8" fill="#dff0ff"/></g></g></g>`;

  // ---- a faint nebula wash drifting behind the planet (reuses .drift) ----
  const nebula = `<g transform="translate(72,44)"><g class="drift" style="animation-duration:16s"><ellipse rx="70" ry="30" transform="rotate(-18)" fill="url(#${uid}nebula)"/></g></g>`;

  // ---- a large distant ringed planet, low-left (cool tones so it never competes with the warm suns) ----
  const planet = `<g transform="translate(56,52)"><g transform="rotate(-24)">
    <path d="M-32,0 A 32 8 0 0 1 32,0" fill="none" stroke="#b9a7d6" stroke-width="2.2" opacity="0.4"/>
    <circle r="19" fill="url(#${uid}planet)"/>
    <path d="M15,11 A19 19 0 0 1 6,18" fill="none" stroke="rgba(207,227,255,0.45)" stroke-width="1.3"/>
    <path d="M-32,0 A 32 8 0 0 0 32,0" fill="none" stroke="#c9b9e2" stroke-width="2.4" opacity="0.8"/>
  </g></g>`;

  // ---- an ominous ORIGINAL battle-station: a dark grey cratered moon-station,
  //      top-right, well clear of the suns and the calm centre (static + a faint glow halo) ----
  const station = `<g transform="translate(316,44)">
    <circle class="glow" r="34" fill="url(#${uid}stnGlow)"/>
    <circle r="28" fill="url(#${uid}stn)"/>
    <g clip-path="url(#${uid}stnClip)">
      <ellipse cx="0" cy="0" rx="28" ry="9" fill="none" stroke="#12161c" stroke-width="0.8" opacity="0.4"/>
      <ellipse cx="0" cy="-10" rx="25" ry="7" fill="none" stroke="#12161c" stroke-width="0.7" opacity="0.3"/>
      <ellipse cx="0" cy="11" rx="24" ry="7" fill="none" stroke="#12161c" stroke-width="0.7" opacity="0.3"/>
      <ellipse cx="0" cy="0" rx="9" ry="28" fill="none" stroke="#12161c" stroke-width="0.7" opacity="0.26"/>
      <g fill="#20252d" opacity="0.75"><circle cx="10" cy="9" r="2.4"/><circle cx="15" cy="-2" r="1.5"/><circle cx="4" cy="15" r="1.7"/><circle cx="-9" cy="6" r="1.3"/></g>
      <g fill="rgba(150,162,180,0.32)"><circle cx="10.4" cy="8.1" r="1"/><circle cx="4.4" cy="14.1" r="0.8"/></g>
    </g>
    <g transform="translate(-7,-9)">
      <ellipse rx="8.5" ry="7.5" fill="url(#${uid}stnDish)"/>
      <ellipse rx="8.5" ry="7.5" fill="none" stroke="#0c0f14" stroke-width="1" opacity="0.7"/>
      <ellipse cx="1" cy="1.2" rx="3.6" ry="3" fill="#0a0d12" opacity="0.6"/>
    </g>
    <path d="M25,-6 A28 28 0 0 1 7,27" fill="none" stroke="rgba(205,214,228,0.42)" stroke-width="1.4"/>
    <circle r="28" fill="none" stroke="#0c0f14" stroke-width="0.8" opacity="0.6"/>
  </g>`;

  // ---- twin suns setting behind the far dune (right of the calm centre) ----
  const suns =
      `<ellipse cx="256" cy="156" rx="150" ry="66" fill="url(#${uid}horizon)"/>`
    + `<g transform="translate(252,150)"><circle class="glow" r="40" fill="url(#${uid}corona)"/></g>`
    + `<circle cx="252" cy="150" r="24" fill="url(#${uid}sunA)"/>`
    + `<circle cx="279" cy="157" r="14" fill="url(#${uid}sunB)"/>`;

  // ---- dune horizon (dusky, receding) ----
  const dunes =
      `<path d="M0,156 Q100,144 200,150 Q292,155 360,148 V220 H0 Z" fill="url(#${uid}dune1)"/>`
    + `<path d="M0,174 Q120,162 214,170 T360,166 V220 H0 Z" fill="url(#${uid}dune2)"/>`;
  const foredune = `<path d="M0,192 Q120,182 240,190 T360,186 V220 H0 Z" fill="url(#${uid}dune3)"/>`;

  // ---- HERO A: an original round-topped astro-droid rolling across the dune ----
  const droid = () => {
    const TRIM = '#8b98ab';
    let bolts = '';
    for (let i = 0; i < 3; i++) {
      const a = (i / 3) * Math.PI * 2;
      bolts += `<circle cx="${(Math.cos(a) * 8).toFixed(1)}" cy="${(-12 + Math.sin(a) * 8).toFixed(1)}" r="1.4" fill="${TRIM}"/>`;
    }
    bolts += `<line x1="-8.5" y1="-12" x2="8.5" y2="-12" stroke="${TRIM}" stroke-width="1" opacity="0.6"/>`;
    return `<g class="sw-drive"><g transform="translate(0,168)">
      <ellipse class="glow" cx="0" cy="-11" rx="20" ry="17" fill="${AC}" opacity="0.13"/>
      <ellipse cx="0" cy="1.5" rx="13" ry="3" fill="rgba(4,8,26,0.4)"/>
      <circle cx="0" cy="-12" r="12.5" fill="url(#${uid}body)" stroke="${TRIM}" stroke-width="0.9"/>
      <g class="sw-roll">${bolts}</g>
      <path d="M-12.4,-12 A12.4 12.4 0 0 0 12.4,-12 Z" fill="rgba(4,8,26,0.22)"/>
      <g class="sw-bob">
        <path d="M-9,-22 A9 9 0 0 1 9,-22 Z" fill="url(#${uid}dome)" stroke="${TRIM}" stroke-width="0.9"/>
        <rect x="-9" y="-23.2" width="18" height="2.4" rx="1.2" fill="${TRIM}"/>
        <path d="M-9,-22 A9 9 0 0 1 9,-22" fill="none" stroke="${AC}" stroke-width="1.4" opacity="0.9"/>
        <circle class="glow" cx="3" cy="-27" r="4" fill="${AC}" opacity="0.35"/>
        <circle cx="3" cy="-27" r="2.6" fill="#0b1120"/>
        <circle cx="3" cy="-27" r="1.5" fill="${AC}"/>
        <circle cx="-4.5" cy="-25" r="1" fill="#ff7a59"/>
        <rect x="-0.7" y="-31.5" width="1.4" height="4.2" rx="0.7" fill="${TRIM}"/>
      </g>
    </g></g>`;
  };

  const heroArt  = droid();
  const heroDefs =
      `<radialGradient id="${uid}body" cx="0.36" cy="0.3" r="0.75"><stop offset="0" stop-color="#eef2f7"/><stop offset="0.5" stop-color="#c2cad6"/><stop offset="1" stop-color="#7c8798"/></radialGradient>`
    + `<linearGradient id="${uid}dome" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#f4f7fb"/><stop offset="1" stop-color="#b3bcc9"/></linearGradient>`;

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="A deep starfield over twin suns setting on a distant dune horizon, with a ringed planet and an original sci-fi hero.">
    <defs>
      <linearGradient id="${uid}sky" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#080d29"/><stop offset="0.42" stop-color="#141a47"/><stop offset="0.72" stop-color="#2f2a5c"/><stop offset="1" stop-color="#5b3f63"/>
      </linearGradient>
      <radialGradient id="${uid}nebula" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="rgba(120,90,200,0.28)"/><stop offset="0.55" stop-color="rgba(70,110,170,0.14)"/><stop offset="1" stop-color="rgba(70,110,170,0)"/>
      </radialGradient>
      <radialGradient id="${uid}planet" cx="0.68" cy="0.62" r="0.62">
        <stop offset="0" stop-color="#7d97b8"/><stop offset="0.55" stop-color="#3d5a82"/><stop offset="1" stop-color="#223049"/>
      </radialGradient>
      <radialGradient id="${uid}stn" cx="0.62" cy="0.6" r="0.72">
        <stop offset="0" stop-color="#727a86"/><stop offset="0.5" stop-color="#3c434c"/><stop offset="1" stop-color="#191d24"/>
      </radialGradient>
      <radialGradient id="${uid}stnDish" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="#0a0d12"/><stop offset="0.6" stop-color="#20252d"/><stop offset="1" stop-color="#3a424c"/>
      </radialGradient>
      <radialGradient id="${uid}stnGlow" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="rgba(150,170,200,0.32)"/><stop offset="0.6" stop-color="rgba(120,140,175,0.12)"/><stop offset="1" stop-color="rgba(120,140,175,0)"/>
      </radialGradient>
      <clipPath id="${uid}stnClip"><circle cx="0" cy="0" r="28"/></clipPath>
      <radialGradient id="${uid}horizon" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="rgba(255,168,92,0.55)"/><stop offset="0.55" stop-color="rgba(214,96,74,0.22)"/><stop offset="1" stop-color="rgba(214,96,74,0)"/>
      </radialGradient>
      <radialGradient id="${uid}corona" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="rgba(255,214,150,0.75)"/><stop offset="1" stop-color="rgba(255,214,150,0)"/>
      </radialGradient>
      <radialGradient id="${uid}sunA" cx="0.5" cy="0.42" r="0.6">
        <stop offset="0" stop-color="#fff3c6"/><stop offset="0.55" stop-color="#ffab48"/><stop offset="1" stop-color="#e8631f"/>
      </radialGradient>
      <radialGradient id="${uid}sunB" cx="0.5" cy="0.42" r="0.6">
        <stop offset="0" stop-color="#ffe6a6"/><stop offset="0.6" stop-color="#ff9a3c"/><stop offset="1" stop-color="#d24f1e"/>
      </radialGradient>
      <linearGradient id="${uid}dune1" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#4a3357"/><stop offset="1" stop-color="#33244a"/></linearGradient>
      <linearGradient id="${uid}dune2" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#2c2143"/><stop offset="1" stop-color="#1c1734"/></linearGradient>
      <linearGradient id="${uid}dune3" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#150f28"/><stop offset="1" stop-color="#0c0a1e"/></linearGradient>
      <radialGradient id="${uid}cglow" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="rgba(255,236,198,0.4)"/><stop offset="0.55" stop-color="rgba(180,150,220,0.16)"/><stop offset="1" stop-color="rgba(180,150,220,0)"/>
      </radialGradient>
      ${heroDefs}
    </defs>
    <rect width="360" height="220" fill="url(#${uid}sky)"/>
    ${nebula}
    ${farStars}
    ${planet}
    ${stars}
    ${ships}
    ${trail}
    ${station}
    ${suns}
    ${dunes}
    <ellipse cx="180" cy="112" rx="72" ry="54" fill="url(#${uid}cglow)"/>
    ${heroArt}
    ${foredune}
  </svg>`;
}

export { starWarsScene };
